import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/routes";
import Toast from "./components/toster/tosts";
import { ToastProvider } from "./components/toster/ToastContext";
// import { LoaderProvider } from "./components/loader/MyCustomLoader";
import { useEffect, useState } from "react";

function App() {
  const [location, setLocation] = useState(null);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (err) => {
          console.warn("Geolocation error:", err.message);
          setLocation(null);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      setLocation(null);
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId="827545473393-u3amkjc8cdm706mrfct2isdt8jjnkmbq.apps.googleusercontent.com">
      <BrowserRouter>
        <ToastProvider>
          {/* Pass location as prop */}
          <AppRoutes location={location} />
          <Toast />
        </ToastProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
